var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#5F6379",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8,20H26.2c-3.4,0-6.2,2.8-6.2,6.2v47.6c0,3.4,2.8,6.2,6.2,6.2h47.6c3.4,0,6.2-2.8,6.2-6.2V26.2 C80,22.8,77.2,20,73.8,20z M47.4,27.4c0-0.8,0.8-1.4,1.6-1.4h23.4c0.8,0,1.4,0.8,1.4,1.6v3c0,0.8-0.8,1.4-1.6,1.4H48.8 c-0.8,0-1.4-0.8-1.4-1.6V27.4z M39.4,26c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3s-3-1.3-3-3C36.4,27.3,37.7,26,39.4,26z M29,26 c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3s-3-1.3-3-3C26,27.3,27.3,26,29,26z M74,72.6c0,0.8-0.8,1.4-1.6,1.4h-45c-0.8,0-1.4-0.8-1.4-1.6 v-33c0-0.8,0.8-1.4,1.6-1.4h45c0.8,0,1.4,0.8,1.4,1.6V72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,52.3c0,1.1-0.9,2-2,2h-7.6c-1.1,0-2-0.9-2-2v-3c0-1.1,0.9-2,2-2H66c1.1,0,2,0.9,2,2V52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,63.3c0,1.1-0.9,2-2,2h-7.6c-1.1,0-2-0.9-2-2v-3c0-1.1,0.9-2,2-2H66c1.1,0,2,0.9,2,2V63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,47.3H33.6c-0.8,0-1.6,0.6-1.6,1.4v15c0,0.8,0.6,1.6,1.4,1.6l0.2,0h15.2c0.8,0,1.6-0.6,1.6-1.4v-15 C50.4,48.1,49.8,47.3,49,47.3z M45,62.2h-7.5c-0.8,0-1.5-0.9-1.5-1.8c0-1.3,1.4-2.1,2.8-2.8c1-0.4,1.1-0.8,1.1-1.3s-0.3-0.8-0.6-1.1 c-0.6-0.5-0.9-1.3-0.9-2.2c0-1.7,1-3.1,2.8-3.1c1.7,0,2.8,1.4,2.8,3.1c0,0.9-0.3,1.7-0.9,2.2c-0.3,0.3-0.6,0.7-0.6,1.1 s0.1,0.8,1.1,1.2c1.4,0.6,2.8,1.5,2.8,2.8C46.5,61.3,45.8,62.2,45,62.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.3494f419d7bd700be56e294961cdc4da.svg";
export { ForwardRef as ReactComponent };